import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch } from 'react-redux';
import { WaterSupplyDistributionNetworkPostDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/PreventiveWorkWaterSupply/DistributionNetworkSlice';
import moment from 'moment'

export default function WaterSupplyDistributionNetworkPreventiveWorkPopup(props) {


    const { handleOnCloseClick, open, Flag, handleIsPost, item, EditIcon, apiFlag, rowData, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    // console.log(rowData)

    const [DistributionNetworkPreventiveWorkTextField, setDistributionNetworkPreventiveWorkTextField] = useState({
        readingDate: Flag === 'Update' ? moment(rowData.readingDate).format("YYYY-MM-DD") : '',
        wardName: Flag === 'Update' ? rowData.wardName : '',
        locationDetails: Flag === 'Update' ? rowData.locationDetails : '',
        consumptionMetered: Flag === 'Update' ? rowData.consumptionMetered : '',
        consumptionUnMetered: Flag === 'Update' ? rowData.consumptionUnMetered : '',
        stipulatedMorning: Flag === 'Update' ? rowData.stipulatedMorning : '',
        stipulatedEvening : Flag === 'Update' ? rowData.stipulatedEvening : '',
        actualMorning: Flag === 'Update' ? rowData.actualMorning : '',
        actualEvening: Flag === 'Update' ? rowData.actualEvening : '',
        criticalPointsRequired : Flag === 'Update' ? rowData.criticalPointsRequired : '',
        criticalPointsActual: Flag === 'Update' ? rowData.criticalPointsActual : '',
        criticalPointsNormal: Flag === 'Update' ? rowData.criticalPointsNormal : '',
        criticalPointsAffected : Flag === 'Update' ? rowData.criticalPointsAffected : '',

    })

    const handleDistributionNetworkPreventiveWorkTextField = (e) => {
        setDistributionNetworkPreventiveWorkTextField({ ...DistributionNetworkPreventiveWorkTextField, [e.target.name]: e.target.value })
    }

    const handlePost = () => {
        const data = {
            T_Distri_WS_WaterNetworkSupplyID:Flag === 'Update' ? rowData.t_Distri_WS_WaterNetworkSupplyID : '0',
            ConsumptionMetered:DistributionNetworkPreventiveWorkTextField.consumptionMetered,
            ConsumptionUnMetered:DistributionNetworkPreventiveWorkTextField.consumptionUnMetered,
            StipulatedMorning:DistributionNetworkPreventiveWorkTextField.stipulatedMorning,
            StipulatedEvening:DistributionNetworkPreventiveWorkTextField.stipulatedEvening,
            ActualMorning:DistributionNetworkPreventiveWorkTextField.actualMorning,
            ActualEvening:DistributionNetworkPreventiveWorkTextField.actualEvening,
            CriticalPointsRequired:DistributionNetworkPreventiveWorkTextField.criticalPointsRequired,
            CriticalPointsActual:DistributionNetworkPreventiveWorkTextField.criticalPointsActual,
            CriticalPointsNormal:DistributionNetworkPreventiveWorkTextField.criticalPointsNormal,
            CriticalPointsAffected:DistributionNetworkPreventiveWorkTextField.criticalPointsAffected,           
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId: DashProjectTypeId,
        }
        dispatch(WaterSupplyDistributionNetworkPostDataAPI({ data }))
    }

    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="water_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Water Quantity</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>
                            <div className="row details-row">

                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Date </b></label>
                                        <input type="text" className="form-control"
                                            id="readingDate"
                                            name='readingDate'                                           
                                            value={DistributionNetworkPreventiveWorkTextField.readingDate}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-4" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name </b></label>
                                        <input type="text" className="form-control"
                                            id="wardName"
                                            name='wardName'                                        
                                            value={DistributionNetworkPreventiveWorkTextField.wardName}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-4">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Location Name </b></label>
                                        <input type="text" className="form-control"
                                            id="locationDetails"
                                            name='locationDetails'                                         
                                            value={DistributionNetworkPreventiveWorkTextField.locationDetails}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <h5 className='mt-2'>Water Consumption</h5>
                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Metered </b></label>
                                        <input type="text" className="form-control"
                                            id="consumptionMetered"
                                            name='consumptionMetered'
                                            value={DistributionNetworkPreventiveWorkTextField.consumptionMetered}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Unmetered </b></label>
                                        <input type="text" className="form-control"
                                            id="consumptionUnMetered"
                                            name='consumptionUnMetered'
                                            value={DistributionNetworkPreventiveWorkTextField.consumptionUnMetered}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <h5 className='mt-2'>Supply Scheduled Time</h5>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Stipulated Morning  </b></label>
                                        <input type="text" className="form-control"
                                            id="stipulatedMorning"
                                            name='stipulatedMorning'
                                            value={DistributionNetworkPreventiveWorkTextField.stipulatedMorning}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className="col-12 col-md-6 col-lg-6" >
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Stipulated Evening  </b></label>
                                        <input type="text" className="form-control"
                                            id="stipulatedEvening"
                                            name='stipulatedEvening'
                                            value={DistributionNetworkPreventiveWorkTextField.stipulatedEvening}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Actual Morning </b></label>
                                        <input type="text" className="form-control"
                                            id="actualMorning"
                                            name='actualMorning'
                                            value={DistributionNetworkPreventiveWorkTextField.actualMorning}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Actual Evening </b></label>
                                        <input type="text" className="form-control"
                                            id="actualEvening"
                                            name='actualEvening'
                                            value={DistributionNetworkPreventiveWorkTextField.actualEvening}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <h5 className='mt-2'>Quantified of Critical Point</h5>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Required </b></label>
                                        <input type="text" className="form-control"
                                            id="criticalPointsRequired"
                                            name='criticalPointsRequired'
                                            value={DistributionNetworkPreventiveWorkTextField.criticalPointsRequired}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Actual </b></label>
                                        <input type="text" className="form-control"
                                            id="criticalPointsActual"
                                            name='criticalPointsActual'
                                            value={DistributionNetworkPreventiveWorkTextField.criticalPointsActual}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <h5 className='mt-2'>No of Critical Point</h5>
                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Normal </b></label>
                                        <input type="text" className="form-control"
                                            id="criticalPointsNormal"
                                            name='criticalPointsNormal'
                                            value={DistributionNetworkPreventiveWorkTextField.criticalPointsNormal}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                                <div className=" col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Affected </b></label>
                                        <input type="text" className="form-control"
                                            id="criticalPointsAffected"
                                            name='criticalPointsAffected'
                                            value={DistributionNetworkPreventiveWorkTextField.criticalPointsAffected}
                                            onChange={(e) => handleDistributionNetworkPreventiveWorkTextField(e)}
                                        />
                                    </div>
                                </div>

                            </div>
                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}